import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { saveAs } from 'file-saver';
import moment from 'moment';

interface ProductMatrixState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documents: any[];
    sums: any;
    meta: any;
}

const state: ProductMatrixState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documents: [],
    sums: null,
    meta: null
};

export const REPORT_DATA = 'GET_PRODUCT_MATRIX';

export const actions: ActionTree<ProductMatrixState, RootState> = {
    reset({ commit }) {
        commit('RESET');
    },

    loadData({ commit }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(REPORT_DATA)
                    .raw('reports.product_matrix')
                    .action({
                        client: String(params.clientId),
                        period: moment(params.period).format('YYYY-MM-01')
                    })
            ]).then((result: ServerResult) => {
                const content = result.getOperation(REPORT_DATA).getContent();

                commit('SET_REPORT_DATA', content);
                commit('LOADED_SUCCESS');

                resolve();
            }).catch((error: any) => {
                console.error('[ProductMatrix.loadData] ERROR', { params, error });
                commit('LOADED_ERROR');
                reject(error);
            });
        })
    },

    exportDataAsXLSX({ rootState }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('EXPORT')
                    .raw('reports.product_matrix.export')
                    .action({
                        client: String(params.clientId),
                        period: moment(params.period).format('YYYY-MM-01'),
                        format: 'xlsx'
                    })
            ]).then((result: ServerResult) => {
                const exportOpContent = result.getOperation('EXPORT').getContent();
                const fToken = exportOpContent.token;
                const aToken = (rootState as any).ubic.token;
                const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
                saveAs(fileUrl, 'product_matrix.xlsx');

                resolve();
            }).catch((error: any) => {
                console.error('[ProductMatrix.exportDataAsXLSX] ERROR', { params, error });
                reject(error);
            });
        })
    }
};

export const mutations: MutationTree<ProductMatrixState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_REPORT_DATA(state, data) {
        state.documents = data.documents || [];
        state.sums = data.sums || null;
        state.meta = data.meta || null;
    },

    RESET(state) {
        state.documents = [];
        state.sums = null;
        state.meta = null;
        state.loaded = false;
        state.loading = false;
        state.fatalError = false;
    }
};

const getters = {

};

export const STORE_KEY = '$_client_product_matrix';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
